export default __webpack_public_path__ + "static/media/coffeeroasters.70ce77da.svg";